import { Divider, Drawer, Fab, Grid, IconButton, Paper, Stack, Tooltip, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import AnimateButton from 'ui-component/extended/AnimateButton'
import { IconActivity } from '@tabler/icons';
import { useTheme } from '@mui/material/styles';
import PerfectScrollbar from 'react-perfect-scrollbar';
import NotificationList from 'layout/MainLayout/Header/NotificationSection/NotificationList';
import axiosInstance from 'custom-axios';

// import axiosInstance from 'custom-axios';

const ClientFormActivity = ({ called_from, userId }) => {

    const theme = useTheme();
    const [anchorEl, setAnchorEl] = useState(null);
    const [open, setOpen] = useState(false);

    const [notificationData, setNotificationData] = useState([]);

    useEffect(() => {
        const fetchClientActivity = async () => {
            try {
                const response = await axiosInstance.get(`api/client-activity/${userId}`);
                if (response.success) {
                    setNotificationData(response.data);
                }
            } catch (error) {
                // console.error(error.message);
            }
        };

        if (userId) {
            fetchClientActivity();
        }
    }, [userId]);

    const handleToggle = (event) => {
        setAnchorEl(anchorEl ? null : event.currentTarget);
        setOpen(!open);
    };

    return (
        <>
            <Tooltip title="Client Activity">
                <Fab
                    component="div"
                    onClick={handleToggle}
                    size="medium"
                    variant="circular"
                    color="secondary"
                    sx={{
                        backgroundColor: '#124734',
                        borderRadius: 0,
                        borderTopLeftRadius: '50%',
                        borderBottomLeftRadius: '50%',
                        borderTopRightRadius: '50%',
                        borderBottomRightRadius: '4px',
                        top: '25%',
                        position: 'fixed',
                        right: 10,
                        zIndex: theme.zIndex.speedDial
                    }}
                >
                    <AnimateButton type="rotate">
                        <IconButton color="inherit" size="large" disableRipple>
                            <IconActivity />
                        </IconButton>
                    </AnimateButton>
                </Fab>
            </Tooltip>

            <Drawer
                anchor="right"
                onClose={handleToggle}
                open={open}
                PaperProps={{
                    sx: {
                        width: '20%',
                        paddingTop: called_from == 'client' ? '70px' : ''
                    }
                }}
            >
                <PerfectScrollbar component="div"> {/*  set width for inner content  */}
                    <Paper sx={{ marginLeft: 0 }}>
                        <Grid container spacing={1}>
                            <Grid item xs={12}>
                                <Grid container alignItems="center" justifyContent="space-between" sx={{ padding: '20px', marginLeft: '5px', marginTop: '3px' }}>
                                    <Grid item>
                                        <Stack direction="row" spacing={2}>

                                            <Typography variant="subtitle1"><strong>Client Activity</strong></Typography>

                                            {/* {notificationData.length > 0 &&
                                                <Chip
                                                    size="small"
                                                    label={notificationData.length}
                                                    sx={{
                                                        color: theme.palette.background.default,
                                                        bgcolor: theme.palette.warning.dark
                                                    }}
                                                />
                                            } */}
                                        </Stack>
                                    </Grid>
                                    {/* <Grid item>
                                        <Typography component={Link} to="#" variant="subtitle2" color="primary">
                                            Mark as all read
                                        </Typography>
                                    </Grid> */}
                                </Grid>
                            </Grid>

                            <Grid item xs={12} sx={{ pt: 0 }}>
                                <PerfectScrollbar className='ps-full-height'>

                                    <Grid item xs={12} p={0}>
                                        <Divider sx={{ my: 0 }} />
                                    </Grid>

                                    <NotificationList userId={userId} notificationData={notificationData} />

                                </PerfectScrollbar>
                            </Grid>

                            {/* <Divider />
                            <Grid container justifyContent="center">
                                <CardActions sx={{ p: 1.25 }}>
                                    <Button size="small" disableElevation>
                                        View All
                                    </Button>
                                </CardActions>
                            </Grid> */}
                        </Grid>
                    </Paper>
                </PerfectScrollbar>
            </Drawer>
        </>
    )
}

export default ClientFormActivity